import React, { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export default class SwiperSection extends Component {
    constructor(props){
        super(props);
        this.image=['https://www.washmartindia.in/static/media/1.a8aafc01.png',
        'https://www.washmartindia.in/static/media/2.4ff1fd2d.png',
        'https://www.washmartindia.in/static/media/3.c28dcfcb.png',
        'https://www.washmartindia.in/static/media/4.f9192839.png',
        'https://www.washmartindia.in/static/media/5.ac5eec73.png',
        'https://www.washmartindia.in/static/media/6.f85ade66.png',
        'https://www.washmartindia.in/static/media/7.f85ade66.png',
        'https://www.washmartindia.in/static/media/8.5d606c07.png'];
        this.state={
            selectedImageIndex: 0
        }
    }

//function for selection of image which is to be displayed
    onClickChangeI =(index)=>{
        this.setState({
            selectedImageIndex: index
        })
    }
  render() {
    const{selectedImageIndex}=this.state
    return (
    <React.Fragment>
    <img src={this.image[selectedImageIndex]} alt='tag' width='100%'></img>
        <div className='swiper'>
          <Swiper
            spaceBetween={0}
            slidesPerView={3}>
            {this.image.map((img, index)=>(
            <SwiperSlide key={index}><img onClick={()=> this.onClickChangeI(index)} src={img} alt='slide' width='100%' height='100%'></img></SwiperSlide>
            ))}
            </Swiper>
        </div>
    </React.Fragment>
    )
  }
}
